import styled from "styled-components";

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Wrapperbanner = styled.div`
  position: relative;
  max-width: 600px;

  @media screen and (max-width: 500px) {
    width: 95vw;
    transform: translateY(-80px);
  }
`;

export const WrapperClose = styled.div`
  position: absolute;
  z-index: 2;
  top: 4px;
  right: 4px;
  width: 35px;
  height: 35px;
  background-color: rgba(0, 0, 0, 0.28);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media screen and (max-width: 500px) {
    width: 20px;
    height: 20px;
  }
`;
